import React, { useState, useEffect } from "react";
import { Button } from "@mantine/core";
import connectors from "./connectors.jsx";

function UnstopabbleDomains() {
  const connector = connectors["UAuth"][0];
  // Get web3-react hooks from UAuthConnector
  const { useIsActivating, useIsActive } = connectors["UAuth"][1];
  const isActivating = useIsActivating();
  const isActive = useIsActive();
  const [connectionStatus, setConnectionStatus] = useState("Disconnected");
  const [error, setError] = useState();
  const [userDomain, setUserDomain] = useState()

  // Handle connector activation and update connection/error state
  const handleToggleConnect = () => {
    // console.log("clicked")
    setError(undefined); // Clear error state

    if (isActive) {
      if (connector?.deactivate) {
        void connector.deactivate();
      } else {
        void connector.resetState();
      }
      setConnectionStatus("Disconnected");
    } else if (!isActivating) {
      setConnectionStatus("Connecting...");

      // Activate the connector and update states
      connector
        .activate(1)
        .then(() => {
          setConnectionStatus("Connected");
          setTimeout(() => window.location.reload(true), 1000);
        })
        .catch((e) => {
          connector.resetState();
          setError(e);
        });
    }
    // setTimeout(() => window.location.reload(true), 25000);
    // window.location.reload(true)
  };

  const handleDisconnect = () => {
    if (connector?.deactivate) {
      void connector.deactivate();
    } else {
      void connector.resetState();
    }
    setConnectionStatus("Disconnected");
    setUserDomain()
    localStorage.clear()
  }
  const updateName = () => {
    if(localStorage.getItem('currentDomain')){
      setUserDomain(JSON.parse(localStorage.getItem('currentDomain')))
      // setTimeout(() => window.location.reload(true), 1000);
    }
  }
  useEffect(() => {
    updateName()
  },[setUserDomain])

  return (
    <>
      {localStorage.getItem("currentDomain") ? (
        <Button disabled={false} radius="lg" size="md" color="indigo" sx={{ m: 2 }} style={{marginLeft:"10px"}} onClick={handleDisconnect}>
        {userDomain}
        </Button>

      ) : (
        <Button onClick={handleToggleConnect} disabled={false}>
          {/* {isActive ? "Disconnect" : "unstoppable domains"} */}
          UnstopabbleDomains
        </Button>
      )}
    </>
  );
}

export default UnstopabbleDomains;
